import { checkChallengeSecionId } from '../../../util/challenges';
import { SlideContent, PromotionContent, TakeActionContent } from '../types';

export function getPromoUrl(
  slideContent: SlideContent | PromotionContent | TakeActionContent
): string | undefined {
  const { url } = slideContent as SlideContent | PromotionContent;
  if (!slideContent.chid.startsWith('PB') || !url) return undefined;

  if (!url.endsWith('/challenge')) return url;

  const partsArray = url.split('/');
  if (
    partsArray.length < 3 ||
    partsArray[partsArray.length - 1] !== 'challenge' ||
    checkChallengeSecionId(partsArray[partsArray.length - 2])
  ) {
    return undefined;
  }
  return `/${partsArray[partsArray.length - 2]}/${partsArray[partsArray.length - 1]}`;
}
